/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type home_viewer$ref: FragmentReference;
export type home_viewer = {|
  +main: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +slug: ?string,
        +mainPageOrder: number,
        +title: ?string,
        +categoryName: ?string,
        +availableAt: ?string,
        +preview: ?{|
          +filename: ?string,
          +type: MediaFileTypeEnum,
          +preview: ?string,
        |},
      |}
    |}>
  |},
  +news: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +slug: ?string,
        +title: ?string,
        +mainPageOrder: number,
        +categoryName: ?string,
        +availableAt: ?string,
        +preview: ?{|
          +filename: ?string,
          +type: MediaFileTypeEnum,
          +preview: ?string,
        |},
      |}
    |}>
  |},
  +articles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +slug: ?string,
        +mainPageOrder: number,
        +title: ?string,
        +categoryName: ?string,
        +availableAt: ?string,
        +preview: ?{|
          +filename: ?string,
          +type: MediaFileTypeEnum,
          +preview: ?string,
        |},
      |}
    |}>
  |},
  +$fragmentRefs: ArticleSelector_viewer$ref,
  +$refType: home_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "Literal",
  "name": "hidden",
  "value": false,
  "type": "Boolean"
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mainPageOrder",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "availableAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preview",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaFile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "filename",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "preview",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Article",
        "plural": false,
        "selections": [
          v1,
          v2,
          v3,
          v4,
          v5,
          v6,
          v7
        ]
      }
    ]
  }
],
v9 = {
  "kind": "Literal",
  "name": "d",
  "value": true,
  "type": "Boolean"
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 3,
  "type": "Int"
},
v11 = {
  "kind": "Literal",
  "name": "h",
  "value": false,
  "type": "Boolean"
};
return {
  "kind": "Fragment",
  "name": "home_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ArticleSelector_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": "main",
      "name": "articles",
      "storageKey": "articles(first:1,h:true,hidden:false)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "h",
          "value": true,
          "type": "Boolean"
        },
        v0
      ],
      "concreteType": "ArticleConnection",
      "plural": false,
      "selections": v8
    },
    {
      "kind": "LinkedField",
      "alias": "news",
      "name": "articles",
      "storageKey": "articles(d:true,first:3,h:false,hidden:false,section:\"U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=\")",
      "args": [
        v9,
        v10,
        v11,
        v0,
        {
          "kind": "Literal",
          "name": "section",
          "value": "U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=",
          "type": "ID"
        }
      ],
      "concreteType": "ArticleConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Article",
              "plural": false,
              "selections": [
                v1,
                v2,
                v4,
                v3,
                v5,
                v6,
                v7
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "articles",
      "name": "articles",
      "storageKey": "articles(d:true,first:3,h:false,hidden:false,section:\"U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=\")",
      "args": [
        v9,
        v10,
        v11,
        v0,
        {
          "kind": "Literal",
          "name": "section",
          "value": "U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=",
          "type": "ID"
        }
      ],
      "concreteType": "ArticleConnection",
      "plural": false,
      "selections": v8
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '722d06e4d977cf067479e2f695acab7a';
module.exports = node;



// WEBPACK FOOTER //
// src/components/home/__generated__/home_viewer.graphql.js